// initial state
const state = () => ({
    propsalTabs: [
        {
            id: "view-job-tab",
            href: "view-job",
            label: "View job",
            labelMobile: "View",
            component: "ViewJob",
            total: 0,
            showTotal: false,
        },
        {
            id: "invite-applicants-tab",
            href: "invite-applicants",
            label: "Invite experts",
            labelMobile: "Invites",
            component: "Invite",
            total: 0,
            showTotal: false,
        },
        {
            id: "applicants-tab",
            href: "applicants",
            label: "Applicants",
            labelMobile: "Applicants",
            component: "Applicants",
            total: 0,
            showTotal: true,
        },
        {
            id: "hires-tab",
            href: "hires",
            label: "Hires",
            labelMobile: "Hires",
            component: "Hires",
            total: 0,
            showTotal: true,
        },
    ],
    applicantsTab: [
        {
            id: "active-tab",
            href: "active",
            label: "Active",
            component: "ActiveApplicants",
            total: 0,
            showTotal: true,
        },
        {
            id: "shortlist-tab",
            href: "shortlist",
            label: "Shortlist",
            component: "ShortListedApplicants",
            total: 0,
            showTotal: true,
        },
        {
            id: "messaged-tab",
            href: "messaged",
            label: "Messaged",
            component: "MessagedApplicants",
            total: 0,
            showTotal: true,
        },
        {
            id: "hidden-tab",
            href: "hidden",
            label: "Hidden",
            component: "HiddenApplicants",
            total: 0,
            showTotal: true,
        },
    ],
    hiresTab: [
        {
            id: "job-offer-tab",
            href: "job-offers",
            label: "Job offers",
            component: "JobOffersTab",
            total: 0,
            showTotal: true,
        },
        {
            id: "hired-tab",
            href: "hired",
            label: "Hired",
            component: "HiredTab",
            total: 0,
            showTotal: true,
        },
    ],
    inviteTab: [
        {
            id: "search-tab",
            href: "search-experts",
            label: "Search",
            component: "SearchApplicantTab",
        },
        {
            id: "invited-experts-tab",
            href: "invited-experts",
            label: "Invited experts",
            component: "InvitedExpertsTab",
            total: 0,
            showTotal: true,
        },
        {
            id: "saved-tab",
            href: "saved-experts",
            label: "Saved",
            component: "SavedExpertsTab",
            total: 0,
            showTotal: true,
        },
    ],
});

// getters
const getters = {
    getPropsalTabs: (state) => state.propsalTabs,
    getApplicantsTab: (state) => state.applicantsTab,
    getHiresTab: (state) => state.hiresTab,
    getInviteTab: (state) => state.inviteTab,
};

// actions
const actions = {};

// mutations
const mutations = {
    setPropsalTabs(state, data) {
        state.propsalTabs.find((tab) => tab.href === data.href).total =
            data.total;
    },
    setInviteTab(state, data) {
        state.inviteTab.find((tab) => tab.href === data.href).total = data.total;
    },
    setApplicantsTab(state, data) {
        state.applicantsTab.find((tab) => tab.href === data.href).total =
            data.total;
    },
    setHiresTab(state, data) {
        state.hiresTab.find((tab) => tab.href === data.href).total = data.total;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
